
































import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace, State, Action } from 'vuex-class';
import TopUp from './components/TopUp.vue';
import ExpenditureRecord from './components/ExpenditureRecord.vue';
import TopUpRecord from './components/TopUpRecord.vue';
import { topUpRecord, expenditureRecord, balance, userInfo, STOR_NAME } from './api/index';

const Modules = namespace(STOR_NAME);

@Component({
  components: {
    TopUp,
    ExpenditureRecord,
    TopUpRecord,
  },
})
export default class CoinRecord extends Vue {
  @Modules.State('userInfo') userInfoData!: any;
  @Modules.State('balanceC') balanceC!: any;
  @Modules.Action fetchUserInfo!: () => void;
  @Modules.Action fetchBalance!: () => void;
  activeComponent = 'TopUp';
  avatar = require('./assets/shangyou.png');
  activeClass = 1;
  get userName() {
    return this.userInfoData === 0
      ? '未登录'
      : this.userInfoData.nickname ||
          `${this.userInfoData.phone.slice(
            0,
            3,
          )}****${this.userInfoData.phone.slice(7, 11)}`;
  }
  bottomBtnArr = [
    {
      id: 1,
      text: '消费记录',
      img: require('./assets/expenditure-record.png'),
      component: 'ExpenditureRecord',
    },
    {
      id: 2,
      text: '在线充值',
      component: 'TopUp',
      img: require('./assets/online-topup.png'),
    },
    {
      id: 3,
      text: '充值记录',
      component: 'TopUpRecord',
      img: require('./assets/topup-record.png'),
    },
  ];
  async created() {
    console.log(this.userInfoData);
    await this.fetchUserInfo();
    await this.fetchBalance();
  }

  mounted() {
    this.fromSuccessPage();
  }

  handleClickBottomBtn(index: number, cpm: string) {
    this.activeClass = index;
    this.activeComponent = cpm;
  }
  // 判断从充值页面返回来的
  fromSuccessPage() {
    const url = window.location.href;
    if (url.indexOf('?cmp=TopUpRecord') > -1) {
      console.log('from TopUp success!');
      const tempArr = url.split('=');
      this.activeClass = 2;
      this.activeComponent = tempArr[1];
      this.fetchUserInfo();
      this.fetchBalance();
    }
  }
}
